import { Tooltip } from 'ant-design-vue'
import { createVNode } from 'vue'
export const ACTION_COLUMN = {
  title: '操作',
  dataIndex: 'operation',
  fixed: 'right'
}
export const ORDER_COLUMN: any = {
  title: '排序',
  dataIndex: 'order',
  width: 120,
  sorter: true,
  form: {
    type: 'number',
    default: 0,
    attrs: {
      precision: 0,
      min: 0
    }
  }
}
export const STATE_COLUMN: any = {
  title: '状态',
  dataIndex: 'isOpen',
  width: 80,
  form: {
    type: 'numberSwitch',
    default: 1
  }
}
export const BASE_COLUMNS: any = [
  {
    title: '备注',
    dataIndex: 'mark',
    ellipsis: true,
    width: 300,
    customRender({ text }: any) {
      return text
        ? createVNode(
            Tooltip,
            {
              placement: 'topLeft',
              title: text
            },
            () => text
          )
        : ''
    },
    form: {
      type: 'textarea',
      col: { span: 24 }
    }
  },
  { title: '创建时间', dataIndex: 'createdAt', width: 180, sorter: true },
  { title: '更新时间', dataIndex: 'updatedAt', width: 180, sorter: true }
]
export const BASE_FORM_SCHEMA: any = [
  {
    title: '排序',
    dataIndex: 'order',
    type: 'number',
    default: 0,
    attrs: {
      precision: 0,
      min: 0
    }
  },
  {
    title: '状态',
    dataIndex: 'isOpen',
    type: 'numberSwitch',
    col: { span: 24 },
    default: 1
  },
  {
    title: '备注',
    dataIndex: 'mark',
    type: 'textarea'
  }
]

export const DEFAULT_INTERVAL = 10 * 1000
